import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import feedType from '../../../../context/FeedContext/config/feedTypes';
import CheckInStats from '../../../../components/CheckInStats';
import ClientWeightChartModal from '../../../../components/ClientWeightChart';

import useUserDoc from '../../../../hooks/useUserDoc';
import { ActivityContentContainer } from './styles';

const ActivityContent = ({ activity }) => {
  const [showWeightHistoryModal, setShowWeightHistoryModal] = useState(false);

  const { userDoc } = useUserDoc(activity.user);
  const isLastAssignedDateInPast = activity.type === feedType.NEED_NEW_WORKOUTS
  && userDoc?.data?.lastWorkoutAssignedDate
  && moment.utc(userDoc.data.lastWorkoutAssignedDate.toDate()).isBefore(moment.utc(), 'day');

  if (activity.type === feedType.CHECK_IN) {
    return (
      <>
        <CheckInStats
          isNotification
          activity={activity}
          title={activity.content}
          onWeightHistoryClick={() => setShowWeightHistoryModal(true)}
        />
        {showWeightHistoryModal && (
          <ClientWeightChartModal
            showModal={showWeightHistoryModal}
            onClose={() => setShowWeightHistoryModal(false)}
            clientId={activity.user}
          />
        )}
      </>
    );
  }
  return (
    <ActivityContentContainer
      isLastAssignedDateInPast={isLastAssignedDateInPast}
    >
      {activity.content}
    </ActivityContentContainer>
  );
};

ActivityContent.propTypes = {
  activity: PropTypes.object,
};

ActivityContent.defaultProps = {
  activity: {},
};

export default ActivityContent;
